import { useQuery } from "@tanstack/react-query";
import apiClient from "../model/requestUtils";
import { ENDPOINTS } from "../model/authEndpoints";
import { useAuthStore } from "./useAuthStore";
import type { User } from "../model/type";

export function useMe() {
  const accessToken = useAuthStore((s) => s.accessToken);
  const setUser = useAuthStore((s) => s.setUser);

  return useQuery({
    queryKey: ["me"],
    queryFn: () =>
      apiClient.get<User>(ENDPOINTS.me).then((r) => {
        setUser(r.data);
        return r.data;
      }),
    enabled: !!accessToken,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
}
